import storage from "./storage";

const getItem = (key) => storage[key];

export default getItem;
